import { Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
  auth: {
    clientId: (process.env.REACT_APP_AZURE_AD_CLIENT_ID || "").trim(),
    authority: (process.env.REACT_APP_AZURE_AD_AUTHORITY || "https://login.microsoftonline.com/common").trim(),
    redirectUri: window.location.origin + "/internal",
  },
  cache: {
    cacheLocation: "sessionStorage",
  },
};

export const internalApiScopes = [(process.env.REACT_APP_AZURE_AD_API_SCOPE || "").trim()];
